export default "__VITE_ASSET__Cj1jpv2j__"